import React from 'react';
import CigecpeCard from './cigecpeCard';
import img1 from '../../../public/images/7-FACTURACION-ELECTRONICA.png';
import img2 from '../../../public/images/8-GUIA-ELECTRONICA.png';
import Button from '../Button';

const Cigecpe = () => {
  return (
    <div className="min-h-screen container mx-auto flex flex-col items-center justify-center mt-16 mb-8 px-5 lg:px-0">
      <h1 className="text-4xl lg:text-5xl font-bold text-center text-blue mb-10">
        CIGE CPE
      </h1>

      <div className="w-full lg:w-3/4 space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <CigecpeCard
            img={img1}
            title0="" // Nuevo título
            title1="Facturación electrónica sin complicaciones"
            description="Con nuestra solución Cige Web, dile adiós a la gestión manual y a los trámites complicados. Emite tus facturas, boletas y notas de crédito de manera rápida y segura, desde cualquier lugar y en cualquier momento.
Solo necesitas una computadora o tu celular con conexión a internet para tener el control total. Así, puedes dedicarte por completo a lo que realmente importa: hacer crecer tu negocio."
            items={[]}
          />
          <CigecpeCard
            img={img2}
            title0="" // Nuevo título
            title1="Emisión de guías de remisión en la nube"
            description="Agiliza tus procesos de envío y transporte con nuestra solución de guías electrónicas. Emite tus guías de manera eficiente desde cualquier lugar, ya sea desde tu computadora o un dispositivo móvil.
Solo necesitas una conexión a internet para generar tus guías y tener el control total de tus despachos. Minimiza errores, reduce costos y optimiza tus operaciones logísticas."
            items={[]}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <CigecpeCard          
            title0="Versión Plus"
            title1="Cige Web"
            title2="En plan Anual 02 Meses Gratis"
            title3="S/ 59"
            title4="S/ 50"
            title5="Mensual sin IGV"
            description=""
            items={[
              'Emite hasta 50 Comprobantes (Facturas, Boletas de Venta, Notas de crédito y Débito).',
              '100% de validez de comprobantes en SUNAT.',
              'Emisión de comprobantes con el logo de tu empresa.',
              'Hasta 2 Usuarios de Ingreso.',
              'Gestiona tus Productos.',
              'Conectado con SUNAT.',
              'Impresión en A4 o Ticket.',
              'Incluye Certificado Digital.',
              'Soporte Via WhatsApp 24x7.',
            ]}
          />
          <CigecpeCard
            title0="Versión Premium"
            title1="Cige Web"
            title2="En plan Anual 02 Meses Gratis"
            title3="S/ 99"
            title4="S/ 90"
            title5="Mensual sin IGV"
            description=""
            items={[
              'Emisión Ilimitada de Comprobantes (Facturas, Boletas de Venta, Notas de crédito y Débito).',
              'Emisión de facturas de exportación.',
              'Emisión de facturas de Anticipo.',
              'Emisión de Guía de Remisión.',
              '100% de validez de comprobantes en SUNAT.',
              'Emisión de comprobantes con el logo de tu empresa.',
              'Usuarios Ilimitados de Ingreso.',
              'Gestiona tus Productos.',
              'Conectado con SUNAT.',
              'Impresión en A4 o Ticket.',
              'Incluye Certificado Digital.',
              'Soporte Via WhatsApp 24x7.',
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default Cigecpe;
